import $ from 'jquery'

$(document).ready(co_vc_button())

function co_vc_button() {}
